import { HStack, Text } from '@skin-seoul/design-system';

import { useProductCard } from '../ProductCardContext';
import { formatCurrency } from '@skin-seoul/service';
import { Convert } from '@skin-seoul/utils';

export const ProductCardInfoPrice = () => {
  const { currency, originalPrice, salePrice } = useProductCard();

  return (
    <HStack alignItems="center" gap={2}>
      {salePrice ? (
        <Convert
          value={salePrice}
          formatter={(salePrice) => (
            <>
              <Text color="primary.400" textStyle="paragraph.large" fontWeight="semibold" whiteSpace="nowrap">
                {formatCurrency(currency, salePrice)}
              </Text>
              <Text
                color="neutral.400"
                textStyle="label.medium"
                fontWeight="normal"
                textDecoration="line-through"
                whiteSpace="nowrap"
              >
                {formatCurrency(currency, originalPrice)}
              </Text>
            </>
          )}
        />
      ) : (
        <Text textStyle="paragraph.large" fontWeight="semibold" color="primary.400">
          {formatCurrency(currency, originalPrice)}
        </Text>
      )}
    </HStack>
  );
};
